import ProfileRepository from '../../domain/repositories/ProfileRepository';
import ProfileDataStoreFactory from '../factories/ProfileDataStoreFactory';
import ProfileDataStore from '../datastores/ProfileDataStore';

export default class ProfileDataRepository implements ProfileRepository {
  getProfile() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfile();
  }

  getStudentType(period: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getStudentType(period);
  }

  getEmailAndPhone() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getEmailAndPhone();
  }

  getProfilePhoto() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfilePhoto();
  }

  getModalityOfStudy() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getModalityOfStudy();
  }

  getProfileTurn(period: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfileTurn(period);
  }

  getProfileData() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfileData();
  }

  getProfileMastersData(type: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfileMastersData(type);
  }

  getProfileTurnByPeriod(period: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfileTurnByPeriod(period);
  }

  sendValidationCode(email: string, phone: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.sendValidationCode(email, phone);
  }

  updateDataProfile(
    newValue: string,
    oldValue: string,
    type: string,
    validationCode: string
  ) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.updateDataProfile(
      newValue,
      oldValue,
      type,
      validationCode
    );
  }

  updateProfile(updateRequests: any) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.updateProfile(updateRequests);
  }

  getPeriods() {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getPeriods();
  }

  validateCodeByType(validationCode: number, field: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.validateCodeByType(validationCode, field);
  }

  getProfileAcl(career: string, plan: string, prog: string, period: string) {
    const authDataStore: ProfileDataStore = ProfileDataStoreFactory.create();
    return authDataStore.getProfileAcl(career, plan, prog, period);
  }
}
